//Translation
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
//Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import styles from './ExportText.module.css'
//React Hooks
import { useState, useEffect } from 'react';
//Dev Hooks
import { useLanguageValue } from '../context/LanguageContext';
import { useGenerateHTML } from '../hooks/useGenerateHTML';
//External libs
import { saveAs } from 'file-saver';
import HtmlDocx from 'html-docx-js/dist/html-docx';

import React from 'react'

const ExportText = ({ project }) => {

    const { t } = useTranslation(['projectpreview']);
    const { preferenceLanguage } = useLanguageValue();
    const { generateHTML } = useGenerateHTML();

    const [docFile, setDocFile] = useState("word");
    const [exportingProject, setExportingProject] = useState(false);

    const templateWord = "*{     accent-color: rgb(255, 153, 0);     box-sizing: border-box;     margin: 0 auto;     font-family: 'Open Sans';     font-weight: 300;   }   .subject {     color: #FFFFFF;     background-color: rgb(255, 123, 0);     padding: 20px;     text-align: center;     display: flex;     align-items: center;     justify-content: center;     margin-bottom: 30px;   }      .mensagem {     color: black;   }      .word {     color: red;   }       .question {     padding: 20px;     font-weight: 600;     font-size: 25px;     color: rgb(255, 123, 0);     margin-left: 10px; margin-top: 5px  }      .option {     font-size: 20px;        }      .display-none {     display: none;   }      .display-block {     display: block;   }      .correct-answer {     text-align: center;     margin-top: 10px;     background-color: #89ff99;     width: 100%;     font-size: 15px;     color: rgb(0, 53, 11);     font-weight: 600;     padding: 15px;   }      .incorrect-answer {     text-align: center;     margin-top: 10px;     background-color: #ff7272;     width: 100%;     font-size: 15px;     color: rgb(255, 255, 255);     font-weight: 600;     padding: 15px;   }      .results {     text-align: center;     background-color: #63e0ff;     width: 100%;     font-size: 25px;     color: rgb(0, 0, 0);     font-weight: 900;     padding: 20px;   }      label{     margin-left: 140px;     color: #4d4d4d;      }      #submitButton{     background-color: #ebebeb;     border: 0;     font-weight: 600;     font-size: 20px;     text-transform: uppercase;     margin-top: 20px;     margin-bottom: 20px;     width: 100%;     padding: 20px;     cursor: pointer;   }      .project-content {     width: 80%;     white-space: pre-line;   }      .title-line {     font-weight: bold;     color: orange;     font-size: 30px;   }    .conclusion {     background-color: rgb(248, 230, 197);     color: #333;     border: 2px solid orange;     border-radius: 4px;     padding-bottom: 20px;     padding-left: 10px;     padding-right: 10px;   }.footer-image {     position: fixed;     bottom: 0;     right: 0;     transform: translateX(-50%);     z-index: 9999;     max-width: 100px; }  .selected { color: orange;}"

    const handleSaveFile = (type) => {
        switch (type) {
            case "word":
                handleSaveDocFile();
                break;
            case "aiken":
                handleSaveAikenFile(project.assessment);
                break;
            case "gift":
                handleSaveGiftFile(project.assessment);
                break;
            default:
        }
    }

    const removeSpecialChar = (str) => {
        console.log("str: " + str)
        str = removeAccents(str);
        str = str.replace(/ /g, "_");
        str = str.replace(/[&\/\\#,+()$~%'":*?<>{}!@¨]/g, '');
        str = str.toLowerCase();
        return str;
    }

    const removeAccents = (text) => {
        const accents = {
            'á': 'a',
            'à': 'a',
            'â': 'a',
            'ã': 'a',
            'ä': 'a',
            'é': 'e',
            'è': 'e',
            'ê': 'e',
            'ë': 'e',
            'í': 'i',
            'ì': 'i',
            'î': 'i',
            'ï': 'i',
            'ó': 'o',
            'ò': 'o',
            'ô': 'o',
            'õ': 'o',
            'ö': 'o',
            'ú': 'u',
            'ù': 'u',
            'û': 'u',
            'ü': 'u',
            'ñ': 'n',
            'ç': 'c',
            '&': 'and',
        };

        return text
            .split('')
            .map((char) => accents[char] || char)
            .join('');
    };

    const subjectWithouSpecialChar = removeSpecialChar(project.subject);

    const handleSaveAikenFile = (assessment) => {
        setExportingProject(true)
        let aikenTxt = ``;

        assessment.forEach((item, index) => {
            const questionNumber = index + 1;
            const questionText = item.ask_question;
            const correctAnswer = item.correct_answer;
            const alternatives = item.alternatives;

            //aikenTxt += `${questionNumber}. ${questionText}\n`;
            aikenTxt += `${questionText}\n`;

            alternatives.forEach((alternative, altIndex) => {
                const optionLetter = alternative.option.toUpperCase();
                aikenTxt += `${optionLetter}. ${alternative.text}\n`;
            });

            aikenTxt += `\nANSWER: ${correctAnswer.toUpperCase()}\n\n`;
        });
        const blob = new Blob([aikenTxt], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, `${subjectWithouSpecialChar}.txt`);
        setExportingProject(false)
        return aikenTxt;
    }

    const handleSaveGiftFile = (assessment) => {
        setExportingProject(true)
        let giftTxt = '';

        assessment.forEach((item, index) => {
            const questionNumber = index + 1;
            const questionText = item.ask_question;
            const correctAnswer = item.correct_answer;
            const alternatives = item.alternatives;

            giftTxt += `::Q${questionNumber}:: ${questionText} {`;

            alternatives.forEach((alternative, altIndex) => {
                const optionLetter = String.fromCharCode(97 + altIndex).toUpperCase();
                giftTxt += `~%${optionLetter}#${alternative.text}`;
                if (correctAnswer === optionLetter) {
                    giftTxt += ' =100%';
                }
            });

            giftTxt += '}\n';
        });

        const blob = new Blob([giftTxt], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, `${subjectWithouSpecialChar}.gift`);
        setExportingProject(false)
        return giftTxt;
    };

    const handleSaveDocFile = async () => {
        const htmlString = handleGenerateHTML("word");
        const docx = HtmlDocx.asBlob(htmlString);
        saveAs(docx, `${subjectWithouSpecialChar}`);
    }

    const handleGenerateHTML = (destiny, imageContents, videofile) => {

        const projectInfos = {
            css: templateWord,
            templateName: project.nameTemplate,
            projectName: project.projectName,
            projectDestiny: destiny,
            introAssessment: project.projectIntro,
            projectContent: project.contentGenerated,
            assessment: project.assessment,
            language: project.language,
        }
        return generateHTML(projectInfos);
    }

    useEffect(() => {
        if (preferenceLanguage) {
            var language = "en";
            switch (preferenceLanguage) {
                case "Português":
                    language = "pt"
                    break;
                case "Espanhol":
                    language = "es"
                    break;
                case "Inglês":
                    language = "en"
                    break;
            }
            changeLanguage(language);
            i18n.changeLanguage(language);
        }
    }, [preferenceLanguage])

    const changeLanguage = (language) => {
        localStorage.setItem('preferenceLanguage', language);
        i18n.changeLanguage(language);
    };

    return (
        <div>
            <div className="mt-4 ms-3">
                <div className={`form-check mt-2 ${docFile === 'docfile1' ? styles.actual_choice : ''}`}>
                    <input className={`form-check-input ${styles.option_check}`} type="radio" name="docRadioDefault" id="word" onChange={(event) => setDocFile(event.target.id)} checked={docFile === 'word'} />
                    <span className={`form-check-label ${styles.texts_format}`}>
                        {t('projectpreview:exporttext.Word simples')}
                    </span>
                </div>
                <div className={`form-check mt-3 ${docFile === 'docfile2' ? styles.actual_choice : ''}`}>
                    <input className={`form-check-input ${styles.option_check}`} type="radio" disabled={false} name="docRadioDefault" id="aiken" onChange={(event) => setDocFile(event.target.id)} checked={docFile === 'aiken'} />
                    <span className={`form-check-label ${styles.texts_format}`}>
                        {t('projectpreview:exporttext.TXT formato Aiken')}
                    </span>
                </div>
                <div className={`form-check mt-3 ${docFile === 'docfile3' ? styles.actual_choice : ''}`}>
                    <input className={`form-check-input ${styles.option_check}`} type="radio" disabled={false} name="docRadioDefault" id="gift" onChange={(event) => setDocFile(event.target.id)} checked={docFile === 'gift'} />
                    <span className={`form-check-label ${styles.texts_format}`}>
                        {t('projectpreview:exporttext.Word formato GIFT')}
                    </span>
                </div>
                <div className={`mt-4 ${styles.texts_format}`}>
                    <h6>{t('projectpreview:exporttext.Observação Word')}</h6>
                </div>
                <div className="row mt-4">
                    <button className={`${styles.btn_style}`} onClick={() => handleSaveFile(docFile)}>{t('projectpreview:exporttext.Exportar e baixar arquivo')}</button>
                </div>
            </div>
        </div>
    )
}

export default ExportText